export default __webpack_public_path__ + "static/issues-0bce17bd35465dd9ff573cdd14e5cdbd.webp";